var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-money-bg-violet';
                    var viewUrl = 'sprite.svg#view-icon-money-bg-violet';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 55 55',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };